import React, { useEffect, useRef } from 'react';
import { Backdrop, Box, Button, Typography } from '@mui/material';
import { BrandColors } from '../../constants';
import { PromptBoxStyles } from '../styles/promptBox';
import { WCAGStrandardStyles } from '../styles/WCAGStandardStyles';

interface PromptBoxProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  handleButtonClick?: () => void;
}

const PromptBox = (props: PromptBoxProps): React.JSX.Element => {
  const { classes } = PromptBoxStyles();
  const { classes: WCAGClasses } = WCAGStrandardStyles();
  const rrPopupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    rrPopupRef.current?.parentElement?.parentElement?.setAttribute('tabIndex', '0');
    rrPopupRef.current?.parentElement?.parentElement?.focus();
  }, []);

  return (
    <Backdrop open className={classes.rrBackdrop}>
      <Box
        zIndex="modal"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        position="fixed"
        width={1}
        color={BrandColors.white}
        bgcolor={BrandColors.blackWithOpacity9}
        className={classes.box}>
        <div ref={rrPopupRef} className={classes.textAlignCenter}>
          <Box>
            <Typography color="inherit" variant="h1" align="center" className={classes.title}>
              {props.title}
            </Typography>
            <Typography color="inherit" align="center" className={`${classes.content} ${WCAGClasses.h3}`}>
              {props.subtitle}
            </Typography>
          </Box>
          <Button onClick={props.handleButtonClick} className={classes.button}>
            {props.buttonText}
          </Button>
        </div>
      </Box>
    </Backdrop>
  );
};

export default PromptBox;
